var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainIdeaLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 33,
    viewBox: "0 0 23 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28252 32.8208C1.61945 32.5636 1.33571 31.7779 1.68759 31.1516L8.05075 19.802L1.42012 17.2304C-0.247012 16.5839 1.34599 15.5671 1.40592 15.525C5.43138 12.2261 11.4365 7.36296 19.4055 0.864113C19.7272 0.596582 20.1869 0.535135 20.5658 0.68208C21.2288 0.939233 21.5126 1.72489 21.1607 2.35122L14.7975 13.7009L21.4471 16.2798C22.2049 16.5737 22.4821 17.0952 21.72 17.824C11.2699 26.281 5.19011 31.2241 3.44282 32.6387C3.12112 32.9063 2.68035 32.9751 2.28252 32.8208Z",
    fill: "#A8A7CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIdeaLightning);
export default __webpack_public_path__ + "static/media/main-idea-lightning.a2243ee4f28b7916684fef392380bf26.svg";
export { ForwardRef as ReactComponent };